import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { DomSanitizer } from '@angular/platform-browser';
import { Couponsection } from 'src/app/model/couponsection.model';
import { CouponsectionService } from 'src/app/services/couponsection.service';
import { AddcouponService } from 'src/app/services/addcoupon.service';
import { DateService } from 'src/app/services/date.service';

@Component({
  standalone: false,
  selector: 'app-create-new-coupon',
  templateUrl: './create-new-coupon.component.html',
  styleUrls: ['./create-new-coupon.component.scss']
})
export class CreateNewCouponComponent implements OnInit, OnDestroy {

  public couponsection = new Couponsection();
  private subscriptions = new Subscription();

  prakList: any = [];
  finalSubmissionArray = [];
  selectedDate: any;
  formatDate: any;
  selectedToDate: any;
  formatToDate: any;
  afterConvertFile: any = [];
  images = [];
  couponStartDate: any;
  couponEndDate: any;
  minDate = undefined;
  uploadData: any;
  imageName: any;
  minToDate;
  actualDate: Date;
  today: Date;
  todayDate;

  myForm!: FormGroup;
  imageTobeUpload: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private acroute: ActivatedRoute,
    private couponsectionService: CouponsectionService,
    private dateAdapter: NgbDateAdapter<string>,
    private dateSrv: DateService,
    private addcouponService: AddcouponService
  ) {

    this.myForm = this.formBuilder.group({
      newCouponGroups: this.formBuilder.array([this.newNotes()]),
      createdBy: '',
      isActive: true,
    });

    localStorage.setItem('expandNavCreateview', 'true');
    const route = this.sideNavService.routingChunks({
      name: 'Create and View',
      subNav: '1',
      subNavLink: '',
    });
    this.appStateSrv.setSideNavState(route);

    const current = new Date();
    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate(),
    };
  }

  ngOnInit(): void {
    localStorage.removeItem('expandNav');
    localStorage.removeItem('expandNavLand');
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavCreateview');
    this.subscriptions.unsubscribe();
  }

  getParkDetails() {
    this.couponsectionService.getParkByCLAId().subscribe((res) => {
      if (res.isValid) {
        this.prakList = res.list;
      }
    });
  }

  onFileChange(event: any, file: any) {

    this.images = [];

    if (event.target.files && event.target.files[0]) {
      const fileItem = event.target.files[0];
      console.log(fileItem);

      var filesAmount = event.target.files.length;

      // for (let i = 0; i < filesAmount; i++) {
      //   var reader = new FileReader();
      //   reader.readAsDataURL(event.target.files[i]);

      //   reader.onload = (innerEvent: any) => {
      //     // this.imgId = this.imgId + 1;
      //     this.images.push({
      //       // imgId: this.imgId,
      //       imgBase64: innerEvent.target.result,
      //       imgFile: event.target.files[i],
      //     });

      //     this.myForm.patchValue({
      //       couponimage: this.images,
      //     });
      //   };
      // }


      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (innerEvent: any) => {
        // this.imgId = this.imgId + 1;
        this.images.push({
          imgBase64: innerEvent.target.result,
          imgFile: event.target.files[0],
        });
        // this.myForm.patchValue({
        //   couponimage: this.images,
        // });
      };

      this.imageName = event.target.files[0].name;
      console.log(event.target.files[0].name);
    }
  }

  onSubmit(): void {

    if (this.myForm.valid) {

      const uploadData = new FormData();

      // for (let i = 0; i <= this.images.length - 1; i++) {
      //   this.afterConvertFile.push(
      //     this.dataURLtoFile(
      //       this.images[i].imgBase64,
      //       this.images[i].imgFile.name
      //     )
      //   );
      // }

      if (this.images.length > 0) {
        this.afterConvertFile.push(
          this.dataURLtoFile(
            this.images[0].imgBase64,
            this.images[0].imgFile.name
          )
        );
      }
      let imgFileProperties = this.afterConvertFile.map(
        (img: any, filename: any) => {
          let properties = {
            photoData: img,
            photoName: img.name,
          };
          return properties;
        }
      );


      // for (let i = 0; i <= imgFileProperties.length - 1; i++) {
      //   uploadData.append(
      //     'CouponImage[' + i + '].photoData',
      //     imgFileProperties[i].photoData
      //   );
      //   uploadData.append(
      //     'CouponImage[' + i + '].photoName',
      //     imgFileProperties[i].photoName.split('?').at(0)
      //   );
      // }


      // uploadData.append('CouponImage', imgFileProperties[0].photoName);


      // this.myForm.patchValue({
      //   CouponImage: imgFileProperties,
      // });

      //for (let i = 0; i <= this.myForm.value.newCouponGroups.length - 1; i++) {

      if(imgFileProperties.length > 0) {
        this.imageTobeUpload = imgFileProperties[0].photoData;
      } else {
        this.imageTobeUpload = null;
      }

      uploadData.append('CouponValidFrom', this.couponStartDate);
      uploadData.append('CouponValidTo', this.couponEndDate);
      uploadData.append('CouponType', this.myForm.value.newCouponGroups[0].coupontype);
      uploadData.append('CouponCount', this.myForm.value.newCouponGroups[0].couponcount);
      uploadData.append('CouponValue', this.myForm.value.newCouponGroups[0].couponvalue);
      uploadData.append('CouponTitle', this.myForm.value.newCouponGroups[0].title);
      uploadData.append('CouponDescription', this.myForm.value.newCouponGroups[0].coupondetails);
      // uploadData.append('CouponImage', imgFileProperties[0].photoData);
      uploadData.append('CouponImage', this.imageTobeUpload);
      uploadData.append('CreatedBy', localStorage.getItem('claAdminId'));
      uploadData.append('IsActive', 'true');

      //}


      this.finalSubmissionArray = [];
      this.addcouponService
        .createNewCouponData(uploadData)
        .subscribe((res) => {
          this.router.navigate(['/list-coupon/']);
        });
    } else {
      this.myForm.markAllAsTouched();
    }

  }

  newCouponGroups(): FormArray {
    return this.myForm.get('newCouponGroups') as FormArray;
  }

  newNotes(): FormGroup {
    return this.formBuilder.group({
      coupontype: ['Generic', Validators.required],
      title: ['', Validators.required],
      couponvalue: ['', Validators.required],
      startdate: ['', Validators.required],
      enddate: ['', Validators.required],
      couponcount: ['', Validators.required],
      coupondetails: ['', Validators.required],
      // couponimage: ['', Validators.required],
      couponimage: [''],
    });
  }

  addMore(): void {
    this.newCouponGroups().push(this.newNotes());
  }

  removeBlock(i: number) {
    this.newCouponGroups().removeAt(i);
  }

  goToListPage() {
    this.router.navigate(['/list-coupon/']);
  }

  public updateSelectedDate(date: NgbDate) {
    console.log(date);
    this.today = new Date();
    this.couponStartDate = date.month + '/' + date.day + '/' + date.year;
    this.actualDate = new Date(this.couponStartDate);
    const jsDate = new Date(date.year, date.month - 1, date.day);
    this.selectedDate = this.convertFormat(date.year, date.month, date.day);

    if (this.actualDate < this.today) {
      this.minToDate = this.todayDate
    }
    else {
      this.minToDate = date;
    }

    this.formatDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );
  }

  public updateSelectedToDate(date: NgbDate) {
    console.log(date);
    this.couponEndDate = date.month + '/' + date.day + '/' + date.year;
    const jsDate = new Date(date.year, date.month - 1, date.day);
    this.selectedToDate = this.convertFormat(date.year, date.month, date.day);

    const delay = (ms) => new Promise((res) => setTimeout(res, ms));

    this.formatToDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );
  }

  convertFormat(y, m, d) {
    return y + '-' + m + '-' + d;
  }

  dataURLtoFile(dataurl: string, filename: any) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[arr.length - 1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename.split('?').at(0), { type: mime });
  }

  goToBulkUploadPage() {
    this.router.navigate(['/bulk-upload-coupon/']);
  }

}
